import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import React, { memo } from 'react';
import styled from 'styled-components';
import { ITextProps } from '@dealstack/frontend/shared/components/fundament/Text/Text.types';

interface Props {
	className?: string;
	title: string;
	children?: React.ReactNode;
	titleProps?: ITextProps;
}

const TagPair = ({ titleProps = {}, className, title, children }: Props) => {
	return (
		<div className={className}>
			<TagPairTitleText elipsis variant="overline" uppercase {...titleProps}>
				{title}
			</TagPairTitleText>
			<TagContent>{children}</TagContent>
		</div>
	);
};

export const TagPairTitleText = styled(Text)``;
export const TagContent = styled.div`
	display: flex;
	align-items: center;
`;

export const TagText = styled(Text).attrs({
	elipsis: true,
	variant: 'p-sm',
})`
	font-weight: 500;
	letter-spacing: 0.04em;
`;

const Memoized = memo(TagPair);
const Styled = styled(Memoized)`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	${TagPairTitleText} {
		color: ${({ theme }) => theme.v2.color.neutral[600]};
	}
`;

export { Styled as TagPair };
